import React, { useState, useEffect } from "react";
import api from "@api";
import { Form } from "@components";
import { InfraAppModel } from "@api/types/infraapp";
import { InfraAppDetail } from "./detail";
import { M_TABLE_HEADERS_INFRA_APP } from "../constants";
import { Cell } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import { FilterType, Table } from "@components";
import { useInfraAppStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportInfrastructureApps } from "@api/excel-exporters/exportInfrastructureApps";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_INFRA_APP.APP_NAME },
  { data: M_TABLE_HEADERS_INFRA_APP.IS_ACTIVE },
  { data: M_TABLE_HEADERS_INFRA_APP.APPROVER },
  { data: M_TABLE_HEADERS_INFRA_APP.APPROVER_DISTRO },
  { data: M_TABLE_HEADERS_INFRA_APP.INFRASTRUCTURE },
];

export const InfraApp: React.FC = () => {
  const [infraAppStore, setInfraAppStore] = useInfraAppStore();
  useEffect(() => {
    if (infraAppStore.fetchList) {
      getDataList();
    }
  }, [infraAppStore]);

  const form = Form.useManager<InfraAppModel>({
    id: 0,
    name: "",
    approver: "",
    approverDistro: null,
    isActive: false,
  });

  const [openInfraApp, setOpenInfraApp] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedInfraApp, setSelectedInfraApp] = useState<any>();
  const [infraAppList, setInfraAppList] = useState([]);

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    if (openInfraApp) {
      if (selectedInfraApp) {
        form.set(Form.target.VALUE, ["id", selectedInfraApp.id]);
        form.set(Form.target.VALUE, ["name", selectedInfraApp.name]);
        form.set(Form.target.VALUE, ["approver", selectedInfraApp.approver]);
        form.set(Form.target.VALUE, [
          "approverDistro",
          selectedInfraApp.approverDistro
            ? selectedInfraApp.approverDistro.id
            : null,
        ]);
        form.set(Form.target.VALUE, [
          "infrastructure",
          selectedInfraApp.infrastructure
            ? selectedInfraApp.infrastructure.id
            : null,
        ]);
        form.set(Form.target.VALUE, ["isActive", selectedInfraApp.isActive]);
      }
    }
  }, [openInfraApp]);

  function getDataList() {
    api.infraapp
      .get()
      .then((response) => {
        setInfraAppList(response.infrastructureApps);
      })
      .catch((error) => {
        console.error(`Error in fetching salesforce role ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        setInfraAppStore({ fetchList: false });
      });
  }

  const isShowModal = openInfraApp ? (
    <InfraAppDetail
      form={form}
      open={openInfraApp}
      onCancel={() => setOpenInfraApp(false)}
    />
  ) : (
    ""
  );

  function handleExport() {
    exportInfrastructureApps();
  }

  const pageName = "Infrastructure Application";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <Table
        data={infraAppList.map((data: any) => ({
          cells: [
            {
              data: data.name,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedInfraApp(data);
                setOpenInfraApp(true);
              },
            },
            {
              data: data.isActive ? "Yes" : "No",
            },
            {
              data: data.approver,
            },
            {
              data: data.approverDistro ? data.approverDistro.name : "",
            },
            {
              data: data.infrastructure ? data.infrastructure.name : null,
            },
          ],
          data,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_INFRA_APP.APP_NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_INFRA_APP_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
